// Customer video testimonials (YouTube), the same ones shown on fbzipper.com.
// `short: true` = a vertical YouTube Short.
export const TESTIMONIALS = [
  { id: '_Uxx7R119-8', short: true },
  { id: 'MzDFpm8BT70' },
  { id: 'sRKqvICZadI' },
  { id: 'Yl7SRegIflw' },
  { id: 'WLebQzwEEaI' },
  { id: 'F5bew0c8WGw' },
  { id: 'RoPDABOH6mU' },
  { id: 'jIWKHBizKEg' },
  { id: '0HeGvvtRCNo' },
  { id: 'D-77ROjC4R8' },
  { id: '_9PkH9NjpFE' },
  { id: 'BlbIoThmxwQ' },
  { id: 'c2wjLoEvm-Y' },
  { id: 'DodFDnWLz6w' },
  { id: '0X40qyH57RA' },
  { id: 'MFMZxWXBr3k' },
  { id: 'YuUx8zcUoV0' },
  { id: '_mFpUjygcQ0' },
  { id: 'ccbiufW2tKY' },
  { id: 'dhWQ3FLu50c' },
  { id: 'tkgU6Fwv9VU' },
  { id: 'KWI50zK-YRY' },
  { id: 'ADDJE4HtfVc' },
  { id: 'RY_5WAGL3mE' },
  { id: '4AoBYbigjIU' },
  { id: 'jcq6tJr9qlA' },
  { id: 'ao6MyItVtYA' },
  { id: 'S0FUKoF9X14' },
  { id: 'ugxHSjlHwLs' },
  { id: 'tsptJv9GemE' },
  { id: '1BqJNZrFjB8' },
  { id: 'I8lyTAmUD38' },
  { id: 'g0hwSDp4BuQ' },
  { id: 'ZKbEyrxFY48' },
  { id: 'kgn2n5PV_34' },
  { id: 'wZ6sXP1wu0Y' },
  { id: 'lAq0QOjnQMM' },
  { id: 'S8TIUKoiPTo' },
];

export const thumb = (id) => `https://img.youtube.com/vi/${id}/mqdefault.jpg`;
